import React from 'react';

import { CustomSVGProps, setSVGColor } from 'styles/theme';

export const Pencil = (props: CustomSVGProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        {...props}
    >
        <path
            stroke={setSVGColor(props)}
            d="M5.80769 12.75H3.25L3.25 10.1874L8.54808 4.87901M5.80769 12.75L12.75 12.75M5.80769 12.75L11.1058 7.44166M8.54808 4.87901L9.64423 3.78074C10.3505 3.07308 11.4956 3.07308 12.2019 3.78074C12.9082 4.48839 12.9082 5.63573 12.2019 6.34339L11.1058 7.44166M8.54808 4.87901L11.1058 7.44166"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
